import s from './NameCellRenderer.scss'
import { Link } from 'react-router-dom'

const NameCellRenderer = ({ data, path }) => {
  if (!data) return null
  const { opportunity_id, opportunity_name } = data

  return (
    <Link className={s.link} to={`/${path}/${opportunity_id}`}>
      {opportunity_name}
    </Link>
  )
}

export default NameCellRenderer
